import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Fade, Grid } from '@material-ui/core'
import { FLEX } from '@v4/constants/quiz'
import { useYesNoButtons } from './YesNoButtons.hooks'
import OptionButton from '../../components/OptionButton'

const YesNoButtons = props => {
	const [{ classes, justify, options, pending, selectedValue }, { handleClick, handleChange }] = useYesNoButtons(
		props,
	)

	return (
		<Grid container spacing={1} justify={justify} className={clsx(classes.root, 'q-buttons')}>
			{_.map(options, ({ id, temporary_id: temporaryId, option }, index) => {
				const optionId = temporaryId || id

				return (
					<Fade key={temporaryId || id} in timeout={index * 100 + 300}>
						<Grid className="q-button-container" item xs={12} sm="auto">
							<OptionButton
								className={clsx(classes.button, 'q-button')}
								disabled={pending}
								loading={pending && selectedValue === optionId}
								id={optionId}
								onClick={handleClick}
								value={option}
								onChange={handleChange}
							/>
						</Grid>
					</Fade>
				)
			})}
		</Grid>
	)
}

YesNoButtons.propTypes = {
	questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClick: PropTypes.func,
	justify: PropTypes.oneOf(Object.values(FLEX)),
	pending: PropTypes.bool,
}

YesNoButtons.defaultProps = {
	pending: false,
	justify: FLEX.START,
	onClick: () => {},
}

export default memo(YesNoButtons)
